import _ from "lodash";
import BaseGrowlAlertView from "scripts/views/baseGrowlAlertView";
import templateCurationMediaAddedGrowlAlert from "templates/curationMediaAddedGrowlAlert.hbs";

class CurationMediaAddedGrowlAlertView extends BaseGrowlAlertView {
  get template() {
    return templateCurationMediaAddedGrowlAlert;
  }

  get events() {
    return _.extend({}, super.events, {
      "click #bb-curation-media-added-view-button": "onClickView",
      "click .close": "onClickClose",
    });
  }

  constructor(options) {
    super(options);

    this.curationId = options.curationId;
  }

  render() {
    this.$el.html(
      this.template({
        curationId: this.curationId,
      }),
    );

    this.animateIn();

    return this;
  }

  onClickView() {
    // User navigated to 'manage curation' page via anchor href.
    this.trigger("close");
  }

  onClickClose() {
    this.trigger("close");

    return false;
  }
}

export default CurationMediaAddedGrowlAlertView;
